import { render, staticRenderFns } from "./CreateOrUpdateUser.vue?vue&type=template&id=76b43d20"
import script from "./CreateOrUpdateUser.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports